@if (configuration.display) {
<div>
    <!-- Results header -->
    <div #anchorTop></div>
    @if (configuration.showHeader) {
    <div
        #header
        class="search-result-header"
        [class.hide]="
            !configuration.listLink &&
            configuration.displayOptions.length <= 1 &&
            !sort.length &&
            !configuration.listTitle &&
            !configuration.showResultsCount
        "
    >
        <!-- Results header count -->
        <div class="search-result-header-left-container">
            @if (configuration.listTitle) {
            <h2 class="is-font-h1 is-font-bold m-0">
                {{ configuration.listTitle }}
            </h2>
            } @if (configuration.showResultsCount) {
            <div class="search-result-header-total">
                <strong [class.is-loading]="isLoading">{{
                    pagination.totalItems
                }}</strong>
                <span> {{ configuration.resultsCountLabel }}</span>
            </div>
            }
        </div>
        <!-- Results sort, display type and link -->
        <div class="search-result-header-right-container">
            <!-- Results header sort -->
            @if (!!configuration.labelTopPagination) {
            <span class="search-result-label">{{
                configuration.labelTopPagination
            }}</span>
            } @if (configuration.showSort && sort.length) {
            <mat-select
                class="is-rounded-small"
                placeholder="Sort by"
                hideSingleSelectionIndicator
                (ngModelChange)="onPaginationSort($event)"
                [(ngModel)]="pagination.sort"
            >
                @for (sortOption of sort; track sortOption) {
                <mat-option [value]="sortOption">
                    {{ configuration.sortOptions[sortOption].label }}
                </mat-option>
                }
            </mat-select>
            } @if (data && configuration.showPaginationSizeAtTop) {
            <mat-select
                class="is-rounded-small"
                hideSingleSelectionIndicator
                [(ngModel)]="pagination.size"
                (ngModelChange)="onPaginationSize($event)"
            >
                @for (size of pagination.sizesAvailable; track size) {
                <mat-option [value]="size">{{ size }} per page</mat-option>
                }
            </mat-select>
            }
            <!-- Results header display type -->
            @if (configuration.displayOptions.length > 1) {
            <div class="search-result-header-options">
                @for (item of configuration.displayOptions; track item) {
                <fa-icon
                    [icon]="['fas', item.icon]"
                    [class.active]="configuration.displayType === item.value"
                    (click)="onChangeDisplayType(item.value)"
                ></fa-icon>
                }
            </div>
            }
            <!-- List -->
            @if (configuration.listLink) {
            <div class="search-result-header-link">
                <a
                    [routerLink]="configuration.listLink"
                    [queryParams]="getParamsListLink()"
                >
                    {{ configuration.listLinkLabel }}
                </a>
            </div>
            }
        </div>
    </div>
    }
    <!-- Results Items -->
    <div class="ras-items-container {{ displayType }}">
        @if (!isLoading) { @for (item of data; track item) {
        <a
            class="is-rounded ras-item-list"
            matRipple
            ras-list-item
            rel="follow"
            (click)="onUnsetNavigation()"
            [routerLink]="getLink(item)"
            [queryParams]="getParams(item)"
            [isLoading]="isLoading"
            [data]="item"
            [configuration]="configuration.childConfigs?.list_item"
        >
        </a>
        }
        <!-- Optional Extra item -->
        @if (configuration.addLastItem && data?.length) {
        <div
            class="is-rounded ras-item-list"
            matRipple
            ras-render-element
            (click)="onUnsetNavigation()"
            [routerLink]="configuration.addLastItem.link"
            [content]="configuration.addLastItem.content"
        ></div>
        } } @else {
        <div class="is-rounded is-loading ras-item-list">
            <figure></figure>
            <div class="content">
                <div class="content-header">
                    <div class="title"></div>
                    <div class="price"></div>
                </div>
            </div>
        </div>
        <div class="is-rounded is-loading ras-item-list">
            <figure></figure>
            <div class="content">
                <div class="content-header">
                    <div class="title"></div>
                    <div class="price"></div>
                </div>
            </div>
        </div>
        <div class="is-rounded is-loading ras-item-list">
            <figure></figure>
            <div class="content">
                <div class="content-header">
                    <div class="title"></div>
                    <div class="price"></div>
                </div>
            </div>
        </div>
        }
        <!-- Loading boilerplate -->
    </div>
    <!-- Not found template -->
    @if (!isLoading && data?.length === 0) {
    <div
        [style]="configuration.noResults?.styles"
        class="search-no-results-container"
    >
        <h1
            [innerHTML]="configuration.noResults?.title"
            [style]="configuration.noResults?.title_styles"
        ></h1>
        <p
            [innerHTML]="configuration.noResults?.subtitle"
            [style]="configuration.noResults?.subtitle_styles"
        ></p>
    </div>
    }
    <!-- Results Pagination -->
    @if (data && configuration.showPagination) {
    <div class="search-pagination">
        <div class="search-pagination-inner">
            <div class="pagination-navigation">
                <button
                    class="is-background-primary"
                    mat-stroked-button
                    [disabled]="canGoPrevious"
                    (click)="onPaginationNavigation(-1)"
                >
                    {{ configuration.listPreviousLabel }}
                </button>
                <button
                    class="is-background-primary"
                    mat-stroked-button
                    [disabled]="canGoNext"
                    (click)="onPaginationNavigation(1)"
                >
                    {{ configuration.listNextLabel }}
                </button>
            </div>
            <div class="pagination-items">
                <ul>
                    @for (item of pagination.pages; track item) {
                    <li
                        [class.active]="item === pagination.index"
                        (click)="onPaginationPage(item)"
                    >
                        {{ item + 1 }}
                    </li>
                    }
                </ul>
            </div>
        </div>
        @if (data && configuration.showPaginationSize) {
        <div class="pagination-size">
            Results
            <mat-select
                class="is-rounded-small"
                hideSingleSelectionIndicator
                [(ngModel)]="pagination.size"
                (ngModelChange)="onPaginationSize($event)"
            >
                @for (size of pagination.sizesAvailable; track size) {
                <mat-option [value]="size">{{ size }}</mat-option>
                }
            </mat-select>
        </div>
        }
    </div>
    }
</div>
}
